<template>
  <div class="setting-seo">
    <form @submit.prevent="onSubmit">
      <section class="section">
        <div class="level is-mobile">
          <div class="level-left">
            <div class="level-item">
              <nav class="breadcrumb" aria-label="breadcrumbs">
                <ul>
                  <li
                    v-for="(item, key) in breadcrumb"
                    :key="key"
                    :class="{'is-active': key === breadcrumb.length - 1}"
                    >
                    <a>{{item}}</a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </section>

      <section class="section">
        <b-tabs>
          <b-tab-item label="Default">
            <seo ref="seo" v-model="metas.default" :disabled="isDisabled" name="Default" />
          </b-tab-item>
          <b-tab-item label="Home">
            <seo ref="seo" v-model="metas.home" :disabled="isDisabled" name="Home" />
          </b-tab-item>
        </b-tabs>
      </section>
      <section class="section">
        <b-field>
          <button class="button is-success" :disabled="isDisabled">Save</button>
        </b-field>
      </section>
    </form>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Seo from '@/components/Seo.vue';

const META = {
  id: null,
  pageId: null,
  title: null,
  description: null,
  ogTitle: null,
  ogDescription: null,
  ogMedia: 'image',
  ogMediaUrl: null,
  ogMediaType: null,
};

export default {
  components: {
    Seo,
  },
  data() {
    return {
      breadcrumb: ['Setting', 'General'],
      isDisabled: false,
      metas: {
        default: Object.assign({ page: 'default' }, META),
        home: Object.assign({ page: 'home' }, META),
      },
    };
  },
  methods: {
    ...mapActions('meta', ['getMetas', 'saveMeta']),
    saveMetas() {
      return Object.keys(this.metas).map(pageName => (
        new Promise(async (resolve, reject) => {
          const meta = this.metas[pageName];

          try {
            if (meta.ogImage) {
              const response = await this.$refs.seo.uploadOgImage();

              Object.assign(meta, {
                ogMediaUrl: response.data.url,
              });
            }

            const response = await this.saveMeta(meta);

            resolve(response);
          } catch (e) {
            reject(e);
          }
        })
      ));
    },
    fetchAllData() {
      Object.keys(this.metas).forEach((pageName) => {
        this.getMetas({
          pageName,
          pageId: false,
          limit: 1,
        }).then(({ data }) => {
          const meta = data.docs.length ? data.docs[0] : {};

          Object.assign(this.metas[pageName], meta);
        });
      });
    },
    onSubmit() {
      this.isDisabled = true;

      Promise.all([
        ...this.saveMetas(),
      ]).then(() => {
        this.$toast.open({
          message: 'Seo saved',
          type: 'is-success',
          duration: 5000,
        });
      }).catch(() => {
        this.$toast.open({
          message: 'Something wrong',
          type: 'is-danger',
          duration: 5000,
        });
      }).finally(() => {
        this.fetchAllData();
        this.isDisabled = false;
      });
    },
  },
  mounted() {
    this.fetchAllData();
  },
};
</script>
